import { SectionLabel, Reveal } from '../components/Section';
import { ShieldCheck } from 'lucide-react';

const FIELDS = [
  { label: 'App Name', value: 'KROY Esports' },
  { label: 'Content Type', value: 'Competitive mobile esports — BGMI and Free Fire tournaments' },
  { label: 'Target Audience', value: '18+ only' },
  { label: 'Bundle ID', value: 'http://app.kroyesports.com' },
  { label: 'Publisher ID', value: 'pub-1564823432030501' },
];

export default function Admob() {
  return (
    <main className="min-h-screen" data-testid="admob-page">
      <div className="max-w-4xl mx-auto px-5 sm:px-8 py-16 sm:py-24">
        <SectionLabel testid="admob-label">AdMob Compliance</SectionLabel>
        <Reveal>
          <h1 className="mt-5 font-display text-white text-4xl sm:text-6xl">
            AdMob Publisher Declaration<span className="text-[#e8173a]">.</span>
          </h1>
        </Reveal>
        <Reveal delay={0.08}>
          <div className="mt-10 card-surface p-7 sm:p-12" data-testid="admob-content">
            <dl className="divide-y divide-white/5">
              {FIELDS.map((f) => (
                <div key={f.label} className="py-4 flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-6" data-testid={`admob-field-${f.label.toLowerCase().replace(/\s+/g, '-')}`}>
                  <dt className="text-[11px] font-extrabold uppercase tracking-[0.2em] text-[#8a8a8a] sm:w-44 shrink-0">{f.label}</dt>
                  <dd className="text-white font-semibold text-sm break-all">{f.value}</dd>
                </div>
              ))}
            </dl>
            <div className="mt-10 border-t border-white/5 pt-8">
              <h2 className="text-sm font-extrabold uppercase tracking-[0.25em] text-[#e8173a] flex items-center gap-2 mb-5">
                <ShieldCheck className="w-4 h-4" /> Ad Policy Compliance Statement
              </h2>
              <div className="space-y-4 text-sm text-[#c9c9c9] leading-relaxed">
                <p>
                  KROY Esports uses Google AdMob to serve advertising inside the app. All ads are served in accordance
                  with Google AdMob Program Policies and Google Publisher Policies.
                </p>
                <p>
                  The app contains competitive mobile esports content (BGMI and Free Fire tournaments) and is intended
                  strictly for users aged 18 and above. Advertising is never targeted at children or minors, and the app
                  is not designed for or directed at users under 18.
                </p>
                <p>
                  Rewarded ads are completely optional — users choose to watch an ad in exchange for in-app bonus coins.
                  Ads never block core gameplay, tournament registration or withdrawals, and no misleading or deceptive
                  ad implementations are used.
                </p>
                <p>
                  Our authorised seller declaration is published at{' '}
                  <a href="/app-ads.txt" data-testid="admob-app-ads-link" className="text-[#e8173a] underline underline-offset-4 decoration-[#e8173a]/40 hover:decoration-[#e8173a] transition-colors">
                    /app-ads.txt
                  </a>{' '}
                  for Publisher ID pub-1564823432030501.
                </p>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </main>
  );
}
